export default Object.freeze({
  RESPONSES: 'RESPONSES',
  UNPUBLISH: 'UNPUBLISH',
  PUBLISH: 'PUBLISH',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  DUPLICATE: 'DUPLICATE'
});
